import { PriceVariant } from '@/components/blocks/HDMPriceDisplay/types';
import { SxProps, Theme } from '@mui/material';
import { OpenSansFontWeights } from 'shared/custom/constants/commonConstants';

const fontSizeMap: Record<PriceVariant, string> = {
	xs: '16px',
	sm: '21px',
	md: '27px',
	lg: '36px',
	xl: '40px',
};

export const priceContainerStyles = (
	variant: PriceVariant,
	fontWeight: number = OpenSansFontWeights.regular
): SxProps => ({
	fontSize: fontSizeMap[variant],
	fontWeight,
	color: 'grey.500',
	display: 'flex',
	alignItems: 'flex-start',
	lineHeight: 1.2,
	gap: '1px',
	fontFamily: '"HelveticaNeue_THD", Open Sans, Helvetica Neue, Arial, sans-serif',
});

export const superscriptStyles = (isLeftPosition: boolean): SxProps<Theme> => ({
	fontWeight: 'inherit',
	lineHeight: '1.2',
	position: 'relative',
	top: '0',
	fontSize: '54%',
	marginLeft: isLeftPosition ? '0' : '1px',
	marginRight: isLeftPosition ? '1px' : '0',
	fontFamily: 'inherit',
});

export const unitStyles = (variant: PriceVariant): SxProps => ({
	fontSize: fontSizeMap[variant],
	fontWeight: OpenSansFontWeights.regular,
	color: 'grey.500',
	fontFamily: '"HelveticaNeue_THD", Open Sans, Helvetica Neue, Arial, sans-serif',
	marginLeft: '3px',
});

interface PriceDisplayStyles {
	mainPriceContainer: SxProps<Theme>;
	offerPrice: SxProps<Theme>;
	listPrice: SxProps<Theme>;
	discountBadge: SxProps<Theme>;
	singleUnit: SxProps<Theme>;
	wholeUnitContainer: SxProps<Theme>;
	wholeOfferContainer: SxProps<Theme>;
	wholeOfferText: SxProps<Theme>;
	wholeOffer: SxProps<Theme>;
	wholeList: SxProps<Theme>;
	wholeSeparator: SxProps<Theme>;
	discountAndListPriceContainer: SxProps<Theme>;
	mainPriceAndUnit: SxProps<Theme>;
	bundlePriceContainer: SxProps<Theme>;
	dashSeparator: SxProps<Theme>;
	savingsText: SxProps<Theme>;
	beforeDiscountText: SxProps<Theme>;
}

export const styles: PriceDisplayStyles = {
	savingsText: {
		color: 'success.main',
	},
	beforeDiscountText: {
		color: 'grey.300',
		textDecoration: 'line-through',
	},
	mainPriceContainer: {
		display: 'flex',
		alignItems: 'center',
	},
	mainPriceAndUnit: {
		display: 'flex',
		alignItems: 'end',
	},
	offerPrice: {
		display: 'flex',
		alignItems: 'baseline',
		fontWeight: OpenSansFontWeights.bold,
		lineHeight: 1,
		color: 'grey.500',
		fontSize: {
			xs: '2rem',
			sm: '2.5rem',
		},
	},
	listPrice: {
		color: 'grey.200',
		textDecoration: 'line-through',
		mt: '0.25rem',
	},
	discountBadge: {
		backgroundColor: 'grey.50',
		color: 'text.highlight',
		fontWeight: OpenSansFontWeights.semibold,
		padding: '2px 5px',
		fontSize: '18px',
		borderRadius: '3px',
	},
	singleUnit: {
		fontWeight: '600',
		lineHeight: 1,
		position: 'relative',
		top: '0',
		fontSize: '54%',
		fontFamily: 'inherit',
	},
	discountAndListPriceContainer: {
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'start',
		ml: '3px',
	},
	wholeUnitContainer: {
		display: 'flex',
		alignItems: 'center',
		mt: '10px',
		color: '#555',
	},
	wholeOfferContainer: {
		display: 'flex',
		alignItems: 'center',
		gap: '3px',
	},
	wholeOfferText: {
		color: 'grey.500',
	},
	wholeOffer: {
		color: 'grey.500',
		marginLeft: '2px',
	},
	wholeList: {
		color: 'grey.200',
		textDecoration: 'line-through',
	},
	wholeSeparator: {
		width: '1px',
		height: '20px',
		backgroundColor: 'grey.200',
		marginLeft: '5px',
		marginRight: '5px',
	},
	bundlePriceContainer: {
		display: 'flex',
		alignItems: 'center',
	},
	dashSeparator: {
		fontSize: '27px',
		margin: '0 8px',
	},
};
